import React from "react";
import { Link } from "react-router-dom";

import "./Link.css";

const Linker = (props) => {
  const className = props.className ? `link ${props.className}` : "link";

  return (
    <Link to={props.to} className={className} style={props.styles} onClick={props.onClick}>
      {props.children}
    </Link>
  );
};

export default Linker;
